import { useState, type ReactElement } from 'react';
import { useT } from '../../../../app/di';
import { Alert } from '../../../../ui-kit/Alert/Alert';
import { Button } from '../../../../ui-kit/Button/Button';
import { FormAlert, FormTextArea, useServerForm } from '../../../../ui-kit/form/form';
import type { ServerOutcome } from '../../../../ui-kit/form/server-errors';

/** MED-UC-4: заметка к медиа. */
export function MediaNoteForm({ note, editable, onSubmit }: { note: string; editable: boolean; onSubmit(note: string): Promise<ServerOutcome> }): ReactElement {
  const { t } = useT();
  const [saved, setSaved] = useState(false);
  const { form, submit } = useServerForm<{ note: string }>({
    defaultValues: { note },
    fields: ['note'],
    onSubmit: async (values) => {
      setSaved(false);
      const outcome = await onSubmit(values.note);
      setSaved(outcome.success);
      return outcome;
    },
  });
  return (
    <form className="u-stack" onSubmit={submit} noValidate>
      {saved ? <Alert tone="success">{t('common.saved')}</Alert> : null}
      <FormAlert form={form} />
      <FormTextArea control={form.control} name="note" label={t('media.card.note')} rows={3} placeholder={t('media.card.notePlaceholder')} disabled={!editable || form.formState.isSubmitting} />
      {editable ? (
        <div>
          <Button type="submit" loading={form.formState.isSubmitting}>
            {t('media.card.saveNote')}
          </Button>
        </div>
      ) : null}
    </form>
  );
}
